import React, { useMemo, useEffect, useState } from "react";
import { MaterialReactTable } from "material-react-table";
import { Button, Typography } from "antd";
import { request } from "../../functions/request";
import Aguarde from "../../components/aguarde/aguarde";
import { AiOutlineSearch, AiFillMessage } from "react-icons/ai";
import { VscCircleLargeFilled } from "react-icons/vsc";
import { MRT_Localization_PT_BR } from "material-react-table/locales/pt-BR";
import { toast } from "react-toastify";
import { Content } from "antd/es/layout/layout";
import ModalResponderDuvida from "../../components/Modal/Duvidas/ModalResponderDuvida";

// Ficha do cliente no CARB — a mesma base que cadastra quem pergunta.
const URL_CLIENTE_CARB = "https://carb.rbvideo.com.br/sistema/cliente/";

const Duvidas = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedDuvida, setSelectedDuvida] = useState({});
  const [haveResult, setHaveResult] = useState(false);
  const [tableData, setTableData] = useState([]);

  const fetchTableData = async () => {
    try {
      const response = await request("/duvidas/getDuvidas", {
        method: "GET",
      });
      setTableData(response);
      setHaveResult(true);
    } catch (error) {
      console.error("Erro na requisição:", error);
      toast.error("Erro ao carregar as dúvidas!");
    }
  };

  useEffect(() => {
    fetchTableData();
  }, []);

  const columns = useMemo(
    () => [
      { accessorKey: "duv_id", header: "Id", size: 10 },
      { accessorKey: "duv_mercado", header: "Mercado", size: 80 },
      {
        accessorKey: "cli_nome",
        header: "Cliente",
        size: 160,
        // O nome é o que se procura ao filtrar; o id sozinho não dizia nada.
        // Continua ordenável/filtrável por nome porque o accessorKey é ele.
        Cell: ({ row }) => {
          const { duv_cliente_id, cli_nome, cli_cidade, cli_estado } = row.original;
          const local = [cli_cidade, cli_estado].filter(Boolean).join("/");
          return (
            <a
              href={`${URL_CLIENTE_CARB}${duv_cliente_id}`}
              target="_blank"
              rel="noopener noreferrer"
              title="Abrir o cadastro do cliente"
              style={{ display: "inline-block", lineHeight: 1.3 }}
            >
              {/* Sem cadastro (cliente removido) o join não traz nome; o id
                  ainda serve para abrir a ficha no CARB. */}
              <div>{cli_nome || `Cliente ${duv_cliente_id}`}</div>
              {local && (
                <div style={{ fontSize: 11, color: "#888" }}>{local}</div>
              )}
            </a>
          );
        },
      },
      { accessorKey: "duv_pergunta", header: "Pergunta", size: 300 },
      {
        accessorKey: "duv_status",
        header: "Status",
        size: 100,
        Cell: ({ cell }) =>
          cell.getValue() === "respondido" ? (
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <VscCircleLargeFilled color="info" fontSize="small" className="active-icon" />
              Respondido
            </div>
          ) : (
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <VscCircleLargeFilled
                color="info"
                fontSize="small"
                style={{ color: "var( --gray-color)" }}
              />
              Pendente
            </div>
          ),
      },
      {
        accessorKey: "duv_data_criacao",
        header: "Data",
        size: 100,
        Cell: ({ cell }) =>
          cell.getValue() ? new Date(cell.getValue()).toLocaleDateString("pt-BR") : "",
      },
    ],
    []
  );

  return (
    <>
      <ModalResponderDuvida
        isOpen={isModalOpen}
        duvida={selectedDuvida}
        onClose={() => setIsModalOpen(false)}
        onSaved={fetchTableData}
      />
      {haveResult ? (
        tableData.length > 0 ? (
          <MaterialReactTable
            columns={columns}
            data={tableData}
            defaultColumn={{ minSize: 5, maxSize: 400, size: 100 }}
            enableColumnFilterModes
            enableColumnSorting
            enableRowActions
            localization={MRT_Localization_PT_BR}
            positionActionsColumn="last"
            enableRowVirtualization
            enableFacetedValues
            columnFilterModeOptions={null}
            initialState={{
              showColumnFilters: true,
              pagination: { pageIndex: 0, pageSize: 20 },
            }}
            displayColumnDefOptions={{
              "mrt-row-actions": { header: "", size: 100 },
            }}
            renderRowActions={({ row }) => (
              <div style={{ display: "flex", gap: "5px", justifyContent: "end" }}>
                {row.original.duv_status === "pendente" && (
                  <Button
                    type="primary"
                    onClick={() => {
                      setSelectedDuvida(row.original);
                      setIsModalOpen(true);
                    }}
                    style={{ display: "flex", alignItems: "center", gap: "5px" }}
                  >
                    <AiFillMessage />
                    Responder
                  </Button>
                )}
              </div>
            )}
            renderTopToolbarCustomActions={() => (
              <Content style={{ display: "flex", alignItems: "center", gap: 20, padding: 10 }}>
                <Typography.Title
                  level={4}
                  style={{ margin: 0, display: "flex", gap: 5, alignItems: "center" }}
                >
                  Perguntas ao Analista
                </Typography.Title>
              </Content>
            )}
            muiTableHeadCellFilterTextFieldProps={{ placeholder: "Filtrar" }}
          />
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "80%",
            }}
          >
            <h2>Nenhuma dúvida enviada ainda.</h2>
            <AiOutlineSearch size={48} color="#888" />
          </div>
        )
      ) : (
        <Aguarde />
      )}
    </>
  );
};

export default Duvidas;
